import { Component, OnDestroy, OnInit } from "@angular/core";
import { StatusListener } from "../../../status-listener";
import { VmcState } from "../../../../shared-gen/Vending/Status/VmcState";
import { AppStatusFun } from "../../../@models/app-status.fun";
import { AppService } from "../../../services/app.service";

@Component({
	selector: "vending-progress",
	templateUrl: "./vending-progress.component.html",
	styleUrls: ["./vending-progress.component.scss"],
})
export class VendingProgressComponent
	extends StatusListener
	implements OnInit, OnDestroy {
	private lastVmcState = VmcState.Intervention;

	steps: { title: string; current: boolean }[] = [
		{
			title: this.translate("🌐General.Vending.Ready"),
			current: true,
		},
		{
			title: this.translate("🌐General.Vending.Paying"),
			current: false,
		},
		{
			title: this.translate("🌐General.Vending.CupPlacing"),
			current: false,
		},
	];

	constructor(app: AppService) {
		super(app);
	}

	ngOnInit() {
		super.ngOnInit();
		this.getStatus();
	}

	onStatusChanged(status) {
		super.onStatusChanged(status);
		this.lastVmcState = AppStatusFun.getVmcState(status);
		this.getStatus();
	}

	getStatus() {
		const vmcState = this.lastVmcState;

		switch (vmcState) {
			case "Inactive":
			case "Ready":
				this.setupAll();
				break;
			case "Paying":
				this.setupAll(false, true);
				break;
			case "CupPlacing":
				this.setupAll(false, false, true);
				break;

			default:
				console.log("Unkown vmcStatus: " + vmcState);
		}
	}

	private setupAll(
		ready: boolean = true,
		paying: boolean = false,
		cupPlacing: boolean = false
	) {
		this.steps[0].current = ready;
		this.steps[1].current = paying;
		if (this.steps[2]) this.steps[2].current = cupPlacing;
	}
}
